import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import styles from "./Experience.module.css";
import { useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
export const Experience = () => {
  const { isLight } = useContext(ThemeContext);
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <Timeline lineColor={"#ddd"}>
          <TimelineItem
            key="001"
            dateText="May 2023 – Present"
            style={{ color: "rgba(113, 46, 255, 0.9)" }}
            dateInnerStyle={{ background: "rgba(113, 46, 255, 0.9)" }}
          >
            <div className={`${!isLight && styles.dark}`}>
              <h3>Advanced Voice Research Lab, </h3>
              <h5>Software Development Engineer - 1</h5>
              <p>
                Managed 6+ Clients, Developed the web based automation solutions
                for clients using Js/Js Frameworks, HTML, CSS, DOM. Developed
                the cachet system using React JS that allows clients to add or
                modify their own logic on their own.
              </p>
            </div>
          </TimelineItem>
          <TimelineItem
            key="002"
            dateText="Aug 2022 – Mar 2023"
            style={{ color: "rgba(113, 46, 255, 0.9)" }}
            dateInnerStyle={{ background: "rgba(113, 46, 255, 0.9)" }}
          >
            <div className={`${!isLight && styles.dark}`}>
              <h3>Convint.ai</h3>
              <h5>Full Stack Developer</h5>
              <p>
                Developed & maintained the most of modules in the application,
                Added new features and Developed the official website of
                convint.ai using React JS and Strapi CMS and Managed the
                website's content with Strapi CMS
              </p>
            </div>
          </TimelineItem>
          <TimelineItem
            key="004"
            dateText="Nov 2019 – May 2021"
            style={{ color: "rgba(113, 46, 255, 0.9)" }}
            dateInnerStyle={{ background: "rgba(113, 46, 255, 0.9)" }}
          >
            <div className={`${!isLight && styles.dark}`}>
              <h3>TVS Brakes India Private Limited</h3>
              <h5>Graduate Engineer Trainee</h5>
            </div>
          </TimelineItem>
        </Timeline>
      </div>
    </>
  );
};
